import { ConfigService } from '../../services/config-service';

export const getSectionsList = ({ currentPage, faqs, trustCard, statusesPlain, promotions }) => {
  const {
    widget,
    content,
    faq,
    trustCard: card,
    coachie,
    statusMapping: { activity },
    type,
    showActivityProgressBlock,
    contentBlock,
    slug,
    repeater
  } = currentPage;

  const {
    DISPLAY_MODULES: { POINTS },
    START_PAGE,
    RESULT_PAGE
  } = ConfigService.get();

  const points = statusesPlain[activity] && statusesPlain[activity].points;

  const sections = [];

  if (content.featuredImage) {
    sections.push(['image', { ...content.images, ...content?.imageData }]);
  }

  if (content.body) {
    sections.push(['body', content.body]);
  }

  if (widget.name && widget.enabled) {
    sections.push(['widget', widget]);
  }

  if (contentBlock && contentBlock.enabled) {
    sections.push(['contentBlock', contentBlock]);
  }

  if (faq.display && faqs) {
    sections.push(['faq', faqs]);
  }

  if (POINTS && promotions && type === 'StartPage' && points && points > 0) {
    sections.push(['points', points]);
  }

  if (repeater?.showRepeater) {
    const repeaterConfiguration = {
      StartPage: START_PAGE.BLOCKS.Repeater,
      ResultPage: RESULT_PAGE.BLOCKS.Repeater
    };

    const repeaterData = {
      repeaterKey: repeater?.repeaterName || slug,
      showRepeater: repeater?.showRepeater,
      ...repeaterConfiguration[type],
      pageType: type
    };

    sections.push(['repeater', repeaterData]);
  }

  if (showActivityProgressBlock) {
    sections.push(['activityProgress', {}]);
  }

  if (['manual', 'digital'].includes(coachie.display)) {
    sections.push(['coachie', coachie]);
  }

  if (card.display && trustCard) {
    sections.push(['trustCard', trustCard]);
  }

  return sortSections({ sections, type, activity });
};

/**
 * Section list
 * @typedef {array} SectionList
 * @property {array<SectionItem>} - section configurations

 * Section item
 * @typedef {array} SectionItem
 * @property {SectionName} name - section name
 * @property {object} - section configuration

 * Section name
 * @typedef {'contentBlock' | 'image' | 'body' | 'widget' | 'faq' | 'points' | 'coachie' | 'trustCard' | 'repeaterBlock'} SectionName

 * Page type name
 * @typedef {'StartPage' | 'ResultPage' | 'InfoPage'} PageType
 */

/**
 * Sort sections by configuration from config file (or Data dictionary) - PAGE_BLOCKS_ORDER
 * @param {array<SectionList>} sections
 * @param {string<PageType>} type
 * @param {string} activity
 *
 * @return Array<SectionList> - list of sections
 */

const sortSections = ({ sections, type, activity }) => {
  const sortConfiguration = ConfigService.get('PAGE_BLOCKS_ORDER', {});

  if (sortConfiguration[type] && (sortConfiguration[type].basic || sortConfiguration[type][activity])) {
    const configuration = sortConfiguration[type][activity] ?? sortConfiguration[type].basic;

    return sections.sort(([aName], [bName]) => {
      if (configuration[aName] && configuration[bName]) {
        return configuration[aName] - configuration[bName];
      }

      if (configuration[aName]) {
        return -1;
      }

      if (configuration[bName]) {
        return 1;
      }

      return 0;
    });
  }

  return sections;
};
